var chunkMapping = {
	"396": [
		20396
	],
	"2345": [
		12345
	],
	"8579": [
		88579
	],
	"9228": [
		19228
	]
};
var idToExternalAndNameMapping = {
	"12345": [
		"default",
		"./WorkspaceMgmtRoutes",
		38960
	],
	"19228": [
		"default",
		"./UserProfile",
		18081
	],
	"20396": [
		"default",
		"./Module",
		64921
	],
	"88579": [
		"default",
		"./UserEventsPanel",
		90140
	]
};
var idToRemoteMap = {
	"12345": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 38960
		}
	],
	"19228": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 18081
		}
	],
	"20396": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 64921
		}
	],
	"88579": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 90140
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}